module.exports = __webpack_public_path__ + "static/media/house-2.ed12ff11.jpeg";